import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CoreModule } from '@dm/core';

import { GraphTreeComponent } from './graph-tree.component';
import { GraphNodeComponent } from './graph-node/graph-node.component';

@NgModule({
    declarations: [GraphTreeComponent, GraphNodeComponent],
    imports: [
        CommonModule,
        CoreModule,
    ],
    exports: [GraphTreeComponent],
})
export class GraphTreeModule { }
